// export const NODE_URL = 'https://fone-network-node.onrender.com'
export const NODE_URL = 'https://fonenetwork.ddns.net'